import React, { useEffect, useState } from "react";
import { DetailsCard, CreditHeader, DetailsText } from "../BookingOverview.styled.js";
import { AddIcon, EditIcon } from "../../../../../Components/Icons/index.js";
import {
  CreditInvoiceButtons,
  BillingAddress,
  CreditInvoiceEmail,
  MissingBillingAddress,
  CreditButton,
  LoadingWrapper,
  FieldForm
} from "./Section.styled.js";
import { useTranslation } from "react-i18next";
import LoadingIndicator from "react-loading-indicator";
import { Expand } from "../../../../../Components/Layout/index.js";
import { Input } from "../../../Previews/Components/index.js";
import Actions from "../../../../../Actions.js";
import { getCountries } from "../../invoice-address-modal/utils.js";

export const InvoiceSection = ({
  editInvoiceAddress,
  currentlySelectedAddress,
  selectedInvoiceAddressData,
  openAddressModal,
  invoiceEntity,
  selectedInvoiceEmail,
  isLoadingInvoiceAddresses,
  poNumber
}) => {
  const { t } = useTranslation();
  const [disableEditBtn, setDisableEditBtn] = useState(true);
  const [showPoNumber, setShowPoNumber] = useState(false);

  const changePoNumber = (value) => {
    Actions.campaignCreateUpdateReviewData({ poNumber: value });
  };

  const mapAddressToString = () => {
    const company = invoiceEntity?.trim() ? <span>{invoiceEntity?.trim()}</span> : null;
    const street = selectedInvoiceAddressData.street ? (
      <span>{selectedInvoiceAddressData.street}</span>
    ) : null;
    const city =
      selectedInvoiceAddressData.zip || selectedInvoiceAddressData.city ? (
        <span>
          {[selectedInvoiceAddressData.zip, selectedInvoiceAddressData.city]
            .filter(Boolean)
            .join(" ")}
        </span>
      ) : null;

    const countryCodeExists =
      selectedInvoiceAddressData.countryCode &&
      getCountries().find((country) => selectedInvoiceAddressData.countryCode === country.value);

    const country = countryCodeExists ? <span>{countryCodeExists.label}</span> : null;

    if (!street && !city && !country) {
      if (isLoadingInvoiceAddresses) {
        return (
          <LoadingWrapper>
            <LoadingIndicator />
            {t("Loading")}
          </LoadingWrapper>
        );
      }
      return <MissingBillingAddress>{t("Please add a billing address.")}</MissingBillingAddress>;
    }

    return (
      <BillingAddress>
        {company}
        {street}
        {city}
        {country}
      </BillingAddress>
    );
  };

  useEffect(() => {
    const { street, city, country, zip } = selectedInvoiceAddressData;
    setDisableEditBtn(!street && !city && !country && !zip);
  }, [selectedInvoiceAddressData]);

  return (
    <DetailsCard>
      <DetailsText>
        <CreditHeader>{t("Billing address")}</CreditHeader>
        <CreditInvoiceButtons>
          <CreditButton
            disabled={disableEditBtn}
            onClick={() =>
              editInvoiceAddress(
                currentlySelectedAddress,
                selectedInvoiceAddressData,
                selectedInvoiceEmail
              )
            }
          >
            <EditIcon strokeWidth={1} size="18" />
          </CreditButton>
          <CreditButton onClick={openAddressModal}>
            <AddIcon strokeWidth={2} size="18" />
          </CreditButton>
        </CreditInvoiceButtons>
      </DetailsText>
      {mapAddressToString()}
      <CreditInvoiceEmail>{selectedInvoiceEmail.value}</CreditInvoiceEmail>

      <Expand
        show={showPoNumber}
        setShow={setShowPoNumber}
        text={t("Add PO number")}
        marginTop="10px"
      >
        <FieldForm clickable>
          <Input
            id="po-number"
            clickIcon={() => setShowPoNumber(false)}
            label={t("PO Number")}
            initValue={poNumber}
            placeholder={`${t("PO Number")} (${t("optional")})`}
            onBlur={changePoNumber}
          />
        </FieldForm>
      </Expand>
    </DetailsCard>
  );
};
